import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "project-remove-modal modal fade",
  tabindex: "-1"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "m-0 ml-2" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-exclamation-circle fa-3x" }, null, -1)),
            _createElementVNode("p", _hoisted_6, [
              _cache[1] || (_cache[1] = _createTextVNode("This will delete project ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.project ? _ctx.project.name : ""), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary btn-cancel",
            "data-dismiss": "modal",
            tabindex: "1"
          }, "Cancel", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
            tabindex: "2"
          }, "Yes, delete")
        ])
      ])
    ])
  ]))
}